/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BinaryFileType } from '../../models/binary-file-type';
import { KeyType } from '../../models/key-type';
import { Token64LengthType } from '../../models/token-64-length-type';

export interface ExternalGetSingleAttachmentForSignature$Heic$Params {
  deliveryNoteKey: KeyType;
  attachmentKey: KeyType;
  token: Token64LengthType;
}

export function externalGetSingleAttachmentForSignature$Heic(http: HttpClient, rootUrl: string, params: ExternalGetSingleAttachmentForSignature$Heic$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
  const rb = new RequestBuilder(rootUrl, externalGetSingleAttachmentForSignature$Heic.PATH, 'get');
  if (params) {
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.path('attachmentKey', params.attachmentKey, {});
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'image/heic', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BinaryFileType>;
    })
  );
}

externalGetSingleAttachmentForSignature$Heic.PATH = '/external/signature-pads/checkin/delivery-note/{deliveryNoteKey}/attachments/{attachmentKey}';
